import React, { useMemo, useEffect, useState } from "react";
import DateBox from "devextreme-react/date-box";
import Tooltip from "devextreme-react/tooltip";
import { dateStore, useRolloverDateResolver } from "./RolloverDateResolver";
import "./RolloverDatebox.css";
import { useSelectedDate } from "./DateContext";
import { Calendar } from "devextreme-react";
import { convertFormatDate } from "../../util/Utils";
import { FormatDate } from "../../api-client-nswag/taxportal-client";

export type RolloverDateBoxProps = {
    disabled?: boolean;
    value?: Date | null;
    rolloverType: number;
    appName: string;
}

export const RolloverDateBox: React.FC<RolloverDateBoxProps> = ({ disabled, value, rolloverType, appName }) => {
  let { disabledDates, resolvedDate, loading } = useRolloverDateResolver(rolloverType.toString(), appName);
  const { selectedDate, setSelectedDate } = useSelectedDate();
  const disabledDateSet = useMemo(() => {
    return new Set(disabledDates.map((date) => date.toDateString()));
  }, [disabledDates]);
  const minDate = useMemo(()=>{
          const d = new Date()
          d.setHours(0,0,0,0);
          return d;
  },[])

  const annotateCalendar = () => {
   const root = document.querySelector('.dx-calendar .dx-calendar-body')
   if (!root) return
   const cells = root.querySelectorAll('.dx-calendar-cell')  
   const targetTimes = new Set(disabledDates.map((date) => date.getTime()));
   cells.forEach((cell) => {
     const existing = cell.querySelector('.queue-label')
     if (existing) existing.remove()
     let raw = cell.getAttribute('data-value') || cell.getAttribute('aria-label')
     let cellDate
     if (raw) {
       const num = Number(raw)
       if (!Number.isNaN(num) && num > 0) {
         cellDate = new Date(num)
       } else {
         const parsed = new Date(raw)
         if (!isNaN(parsed.getTime())) cellDate = parsed
       }
     }
     if (!cellDate) return
     cellDate.setHours(0, 0, 0, 0)
     const time = cellDate.getTime()
     if (targetTimes.has(time)) {
        cell.setAttribute("title", `Queue is Full`);
     }
   })
 }

  const renderCalendarCell = (cellData: any) => {
    const date = new Date(cellData.date);
    date.setHours(0,0,0,0);
    const isBeforeMin = date < minDate;
    const id=`div-date-${cellData.date.getTime()}`;
    return (
      <>
        <div className="custom-calendar-cell" id={id} >
          {isBeforeMin && <div className="queue-label">Queue is Full</div>}
          <span>{cellData.text}</span>
        </div>
        <Tooltip target={`#${id}`} showEvent="mouseenter" hideEvent="mouseleave">
          <div>{isBeforeMin ? "Past min scheduled date" : "Queue is Full"}</div>
        </Tooltip>
      </>
    )
  }

  return (
    <div id="dateboxContainer">
      <DateBox
        min={minDate}
        disabledDates={disabledDates}
        key={disabledDates.length}
        value={value ?? selectedDate ?? undefined}
        width="320px"
        type="date"
        pickerType="calendar"
        displayFormat="MM/dd/yyyy"
        disabled={disabled}
        onValueChanged={(e) => {
          if (!e.value || !e.event) return;
          const newDate=new Date(e.value);
          const now=new Date();
          newDate.setHours(now.getHours());
          newDate.setMinutes(now.getMinutes());
          newDate.setSeconds(now.getSeconds());
          newDate.setMilliseconds(now.getMilliseconds());
          if(!selectedDate|| selectedDate.getTime()!==newDate.getTime()){
          const date = convertFormatDate(newDate.toISOString(), FormatDate.DD) ?? null;
          if (disabledDateSet.has(date)) {
            e.component.option("value", "");
            return;
          }
        
          setSelectedDate(new Date(date));
          dateStore.set(new Date(date)); 
          }
        }}
        
        dropDownOptions={{
          container: "#dateboxContainer",
          width: "320px", 
          showTitle: false,
          hideOnOutsideClick: true,
          onShown: annotateCalendar
        }}
      >
        <Calendar
          zoomLevel="month"
          min={minDate}
          cellTemplate={renderCalendarCell}
          disabledDates={disabledDates}
        />
      </DateBox>
    </div>
  );
};
